import type { SVGProps } from 'react'
const SvgSyShield = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M11.9 23.1c-2.5-.6-4.6-2.1-6.3-4.4s-2.5-4.8-2.5-7.6V4.4l8.8-3.2 8.8 3.3v6.7c0 2.8-.8 5.3-2.5 7.6s-3.8 3.7-6.3 4.4z" />
	</svg>
)
export default SvgSyShield
